import { createFileRoute, redirect } from "@tanstack/react-router";

/** Exact brand URL — permanently redirected to the canonical comparison page. */
export const Route = createFileRoute("/compare/hot/outbid")({
  beforeLoad: () => {
    throw redirect({
      to: "/compare/hot/$competitor",
      params: { competitor: "outbid-lol" },
      statusCode: 301,
    });
  },
});
